import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './lib/theme';
import { trackPageView } from './lib/analytics';
import Header from './components/sections/Header';
import Footer from './components/sections/Footer';
import CookieBanner from './components/CookieBanner';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import DataDeletion from './pages/DataDeletion';
import CookiePolicy from './pages/CookiePolicy';

// Handles hash scrolling when navigating to home from another page, and reports
// a GA page_view on every route change (a no-op until consent + GA are active).
const ScrollToHashElement = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname === '/' && hash) {
      setTimeout(() => {
        const element = document.getElementById(hash.replace('#', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else if (pathname !== '/') {
      window.scrollTo(0, 0); // Scroll to top when changing to a new page
    }
  }, [pathname, hash]);

  useEffect(() => {
    trackPageView(pathname + hash);
  }, [pathname, hash]);

  return null;
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToHashElement />
        <div className="flex flex-col min-h-screen bg-background">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/termini" element={<TermsOfUse />} />
              <Route path="/eliminazione-dati" element={<DataDeletion />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <CookieBanner />
      </Router>
    </ThemeProvider>
  );
}

export default App;
